document.querySelectorAll('.zurueck-link').forEach((link) => {
	link.addEventListener('click', () => {
		window.history.back();
	});
});
